import request from '@/utils/request';
const Qs = require('qs');
// import httpUtil from "@/utils/httpUtil";

export function abc(params) {
	return request({
		url: '/api/websiteLink/queryAll',
		method: 'get'
	});
}

//热点文章
export function setHotArticles() {
	return request({
		url: '/api/website/hotArticles',
		method: 'get'
	});
}

//热门标签
export function getLabelList() {
	return request({
		url: '/api/website/labelList',
		method: 'get'
	});
}

//热门问答
export function getquestionList() {
	return request({
		url: '/api/website/questionList',
		method: 'get'
	});
}

//首页模块
export function getIndex() {
	return request({
		url: '/api/website/index',
		method: 'get'
	});
}

//新闻资讯
export function getArticle(parms) {
	return request({
		url: '/api/website/article?' + Qs.stringify(parms),
		method: 'get'
	});
}

//友情链接
export function getLinks() {
	return request({
		url: '/api/website/links',
		method: 'get'
	});
}

//公司信息
export function getInfo() {
	return request({
		url: '/api/website/info',
		method: 'get'
	});
}

//媒体查询
export function getMedia() {
	return request({
		url: '/api/website/media',
		method: 'get'
	});
}



//文章详情
export function articleById(params) {
	return request({
		url: '/api/website/articleById?' + Qs.stringify(params),
		method: 'get'
	});
}


//提交
export function submit(params) {
	return request({
		url: '/api/website/submit',
		method: 'post',
    data: params
	});
}



// WEBPACK FOOTER //
// ./src/api/api.js